import { Button, Grid, Typography } from "@mui/material";
import React from "react";
import "../assets/css/BoxButton.css";

const BoxButtonAdmin = ({
  onNext,
  onPrevious,
  currentStep,
  removePractice,
  viewBoxButton,
  handleModalClick,
}) => {
  return (
    <Grid
      container
      className="bg-blue-dark"
      style={{
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        padding: "15px 0px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Grid container className="container-box-button">
        <Grid item xs={6} md={6}>
          <Button
            variant="outlined"
            onClick={removePractice}
            className={`button-bg-light ${
              currentStep === 1 ? "button-bg-light-disable" : ""
            }`}
            style={{ display: "block" }}
          >
            <Typography
              className="color-light"
              sx={{
                textTransform: "initial",
                fontSize: { xs: "16px", sm: "18px" },
                fontWeight: 500,
              }}
            >
              Rifiuta pratica
            </Typography>
          </Button>
        </Grid>

        <Grid
          item
          xs={6}
          md={6}
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            variant="contained"
            className="button-bg-purple"
            onClick={handleModalClick}
          >
            <Typography
              className="color-light"
              sx={{
                textTransform: "initial",
                fontSize: { xs: "16px", sm: "18px" },
                fontWeight: 500,
              }}
            >
              {"Approva pratica"}
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BoxButtonAdmin;
